import styled from "styled-components";

export const TurboStripContainer = styled.div`
    padding: ${({ theme }) => `0 ${theme.spacing.medium} 0 ${theme.spacing.medium}`};
`;

export const Footer = styled.div`
    margin-top: 0;
    overflow: hidden;
    padding: ${({ theme }) => `14px ${theme.spacing.medium}`};
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const FooterFirst = styled.div`
    width: 40%;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    outline: none;
`;

export const ButtonWrapper = styled.div`
    width: 60%;
`;

export const LoaderWrapper = styled.div`
    padding-bottom: ${({ theme }) => theme.spacing.medium};
`;
